module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: ({
        offset: -500
      }),
      expression: "{offset: -500}"
    }],
    staticClass: "contact"
  }, [_c('header', {
    staticClass: "heading"
  }, [(_vm.activeLocationData) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.activeLocationData.city && _vm.activeLocationData.city))])]), _vm._v(" "), _c('StickyNavigation', {
    attrs: {
      "navigationLinks": _vm.stickyMenuTabs
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeLocationData) ? _c('div', {
    staticClass: "bg",
    style: ({
      'background-image': 'url( ' + _vm.activeLocationData.image.url + ' )'
    })
  }) : _vm._e()]), _vm._v(" "), [_c('pictured-section', {
    attrs: {
      "data": _vm.locationInfo,
      "id": "link-0"
    }
  }), _vm._v(" "), _c('key-contacts', {
    attrs: {
      "activeLocationData": _vm.activeLocationData
    }
  }), _vm._v(" "), _c('contact-map', {
    attrs: {
      "locationData": _vm.activeLocationData,
      "id": "link-1"
    }
  }), _vm._v(" "), _c('awards-slider-contact-location', {
    attrs: {
      "data": _vm.activeLocationData.awards,
      "id": "link-2"
    }
  })]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-942b7c9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SimplePage.vue
// module id = 355
// module chunks = 0